import { memoize } from "$javascript/memoize";

class DaxCarousel extends HTMLElement {
  @memoize
  get carousel() {
    return this.querySelector('sl-carousel')
  }

  @memoize
  get scroller() {
    return this.querySelector('carousel-scroller');
  }

  @memoize
  get thumbnails() {
    return this.querySelectorAll('carousel-scroller img');
  }

  static {
    customElements.define("dax-carousel", this)
  }

  connectedCallback() {
    // code here mainly copied from Shoelace example:
    this.scroller.addEventListener('click', e => {
      const target = e.target;

      if (target.matches('img')) {
        const index = [...this.thumbnails].indexOf(target);
        this.carousel.goToSlide(index);
      }
    });

    this.carousel.addEventListener('sl-slide-change', e => {
      const slideIndex = e.detail.index;

      [...this.thumbnails].forEach((thumb, i) => {
        thumb.classList.toggle('active', i === slideIndex);
        if (i === slideIndex) {
          thumb.scrollIntoView({
            block: 'nearest'
          });
        }
      });
    });
  }
}

window.showCarouselDialog = (dialogId, slideNum = 1) => {
  const dialog = document.querySelector(`#${dialogId}`)
  dialog.open = true

  setTimeout(() => {
    dialog.querySelector("sl-carousel").shadowRoot.querySelector("[part=scroll-container]").focus()
    dialog.querySelector("sl-carousel").goToSlide(slideNum - 1)
  }, 50)
}
